import CommunicationProgramSummaryContainer from './CommunicationProgramSummaryContainer.js';

export default CommunicationProgramSummaryContainer;